var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCameraEnable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "white",
    strokeWidth: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 16V8a1 1 0 00-1-1H5a1 1 0 00-1 1v8a1 1 0 001 1h10a1 1 0 001-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M20 7l-4 3v4l4 3V7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCameraEnable);
export default __webpack_public_path__ + "static/media/icon-camera-enable.317c25942fc0b1d3dc09f89f2785c380.svg";
export { ForwardRef as ReactComponent };